import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// #app comes from public/index.html id at the bottom
createApp(App).use(store).use(router).mount("#app");
